import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

const ChatHeader = ({ onClose }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid #e0e0e0',
        backgroundColor: '#FFFFFE',
        p: 0.6,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 1 }}>
        <img src="/logo512.png" width="30" alt="PrestoBots" />
        <Typography variant="h6" fontWeight={400}>
          Prestobots Soporte
        </Typography>
      </Box>
      <IconButton onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

ChatHeader.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ChatHeader;
